<template>
  <v-container class="h-100vh d-flex align-center">
    <v-form ref="ref_register" class="form">
      <!-- <v-img src=""/> -->
      <h2 class="text-center">Join Lyricster PRO</h2>
      <p class="text-center">Make the most of your professional life</p>
      <div class="mt-10"></div>
      <v-alert
        type="error"
        border="left"
        class="mb-10"
        v-if="
          authNotification.message != '' && authNotification.type == 'error'
        "
        >{{ authNotification.message }}</v-alert
      >
      <div :class="{ 'd-none': next }">
        <v-row>
          <v-col md="6" class="py-0" cols="12">
            <v-text-field
              solo
              placeholder="First name"
              prepend-inner-icon="fa-user"
              v-model="data.firstname"
              :rules="[myrules.required]"
            ></v-text-field>
          </v-col>
          <v-col md="6" class="pt-0" cols="12">
            <v-text-field
              solo
              placeholder="Last name"
              prepend-inner-icon="fa-user"
              v-model="data.lastname"
              :rules="[myrules.required]"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-text-field
          solo
          placeholder="Username"
          v-model="data.username"
          prepend-inner-icon="fa-user"
          :rules="[myrules.required, myrules.spaces]"
          @input="handleUsernameChange"
          :success="validatingUsername"
          :error="!isUsernameValidated"
          :messages="
            validatingUsername
              ? 'Checking Validity...'
              : !isUsernameValidated
              ? 'Username Already Exist'
              : ''
          "
        ></v-text-field>
        <v-text-field
          solo
          placeholder="Email"
          v-model="data.email"
          prepend-inner-icon="fa-envelope"
          :rules="[myrules.required, myrules.email]"
          @input="handleEmailChange"
          :success="validatingEmail"
          :messages="
            validatingEmail
              ? 'Checking Validity...'
              : !isEmailValidated
              ? 'Email Already Exists'
              : ''
          "
        ></v-text-field>

        <v-text-field
          solo
          type="password"
          placeholder="Password (6 or more character)"
          prepend-inner-icon="fa-lock"
          v-model="data.password"
          :rules="[myrules.required]"
        ></v-text-field>
        <span class="text-left"
          >You agree to the Lyricster PRO
          <router-link to="#">User Agreement</router-link>,
          <router-link to="#">Privacy Policy</router-link>, and
          <router-link to="#">Cookie Policy</router-link>.</span
        >
        <v-btn
          block
          class="mt-4"
          color="primary"
          :disabled="
            !isUsernameValidated ||
            !isEmailValidated ||
            data.email == '' ||
            data.username == ''
          "
          @click="
            (e) => {
              let validate = $refs.ref_register.validate();
              if (
                validate &&
                isUsernameValidated &&
                isUsernameValidated &&
                data.email != '' &&
                data.username != ''
              ) {
                next = true;
                paymentModal = true;
              }
            }
          "
          >Next</v-btn
        >
        <!-- <div style="border: 1px solid #dcdcdc" class="p-2" ref="card"></div> -->
      </div>
      <div :class="{ 'd-none': !next }">
        <v-btn @click="next = false" color="primary"
          ><i class="fa fa-angle-left"></i
        ></v-btn>
        <!-- <span class="mb-6 d-inline-block"
          >Monthly subscription of <b>10$</b></span
        > -->
        <div class="subscriptions my-5">
          <v-radio-group v-model="price_id">
            <v-row>
              <v-col
                lg="6"
                xs="12"
                v-for="subscription of subscriptions.data.filter(
                  (sub) => sub.active != false
                )"
                :key="subscription.id"
              >
                <v-card v-if="subscription.active">
                  <div class="pa-4 d-flex">
                    {{ subscription.nickname }} :
                    {{ subscription.unit_amount / 100
                    }}<span style="text-transform: uppercase">
                      {{ subscription.currency }}</span
                    >
                    <v-radio
                      class="ml-auto"
                      name="amount"
                      :value="subscription.id"
                    />
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-radio-group>
        </div>
        <div
          style="border: 1px solid #dcdcdc"
          class="p-2"
          id="card-element"
        ></div>
        <div class="mt-10">
          <promo-code :info="(data) => lc_promocode_info(data)" />
        </div>
        <!--<v-row>
          <v-col md="6" class="py-0" cols="12">
            <v-text-field
              solo
              placeholder="CVV"
              prepend-inner-icon="fa-credit-card"
            ></v-text-field>
          </v-col>
          <v-col md="6" class="pt-0" cols="12">
            <v-text-field
              solo
              type="date"
              placeholder="Expiry Date"
              prepend-inner-icon="fa-calendar-o"
            ></v-text-field>
          </v-col>
        </v-row> -->
        <v-btn
          block
          :loading="authLoading"
          class="mt-4"
          color="primary"
          @click="lc_register"
          >Agree & Join</v-btn
        >
      </div>
      <div class="d-block d-md-flex mt-6 text-center text-md-left">
        <router-link to="/forget-password">Forget Password?</router-link>
        <br class="d-block d-md-none" />
        <span class="ml-auto"
          >Already on Lyricster PRO?
          <router-link to="/login">Sign in</router-link></span
        >
      </div>
    </v-form>
    <v-dialog width="480px" v-model="paymentModal">
      <img src="@/assets/pricing_popup_before_payment.png" />
    </v-dialog>
  </v-container>
</template>

<script>
import PromoCode from "../components/PromoCode.vue";
import { baseDomain, stripeKey } from "../variables";
// @ is an alias to /src

let stripe = Stripe(stripeKey),
  elements = stripe.elements(),
  card = undefined;
export default {
  components: { PromoCode },
  name: "Signup",
  data() {
    return {
      next: false,
      promocodeInfo: {},
      data: {
        firstname: "",
        lastname: "",
        username: "",
        email: "",
        password: "",
      },
      paymentModal: false,
      price_id: "",
      validatingUsername: false,
      validatingUsernameTimer: null,
      validatingEmail: false,
      validatingEmailTimer: null,
      isUsernameValidated: -1,
      isEmailValidated: -1,
    };
  },
  watch: {
    next(val) {
      if (val == true) {
        this.mountCard();
      }
    },
  },
  methods: {
    async lc_promocode_info(info) {
      console.log(info);
      this.promocodeInfo = info;
    },
    handleUsernameChange(e) {
      console.log("test");
      if (this.validatingUsernameTimer != null) {
        clearTimeout(this.validatingUsernameTimer);
      }
      this.validatingUsername = true;
      this.validatingUsernameTimer = window.setTimeout(() => {
        this.validateUsername({
          username: this.data.username,
          onSuccess: (status) => {
            this.validatingUsername = false;
            this.isUsernameValidated = status;
          },
        });
      }, 2000);
    },
    handleEmailChange(e) {
      console.log("test");
      if (this.validatingEmailTimer != null) {
        clearTimeout(this.validatingEmailTimer);
      }
      this.validatingEmail = true;
      this.validatingEmailTimer = window.setTimeout(() => {
        this.validateEmail({
          email: this.data.email,
          onSuccess: (status) => {
            this.isEmailValidated = status;
            this.validatingEmail = false;
          },
        });
      }, 2000);
    },
    async lc_register(e) {
      e.preventDefault();
      let validate = this.$refs.ref_register.validate();
      let res;
      let error = false;
      try {
        this.$store.commit("setAuthLoading", true);
        res = await stripe.createToken(card);
        if (res.error) {
          alert(res.error.message);
          error = true;
          this.$store.commit("setAuthLoading", false);
          return;
        }
        if (validate && this.price_id != "" && !error) {
          let paymentObj = {
            email: this.data.email,
            planId: this.price_id,
            stripeToken: res.token,
          };

          if (Object.keys(this.promocodeInfo).length != 0) {
            paymentObj["promotion_code"] = this.promocodeInfo.id;
          }
          console.log(paymentObj);
          await this.createSubscription(paymentObj);
          if (
            Object.keys(this.subscription).includes("error") ||
            Object.keys(this.subscription).includes("err")
          ) {
            if (Object.keys(this.subscription).includes("error"))
              alert(this.subscription.error.message);
            if (Object.keys(this.subscription).includes("err"))
              alert(this.subscription.err.message);
            error = true;
            this.$store.commit("setAuthLoading", false);
          }
          if (!error) {
            let obj = {
              customer_id: this.subscription.customer.id,
              subscription_id: this.subscription.subscription.id,
              subscription_plan: {
                expiry: this.subscription.subscription.current_period_end,
                isActive: true,
                price: this.subscription.subscription.plan.amount / 100,
                interval: this.subscription.subscription.plan.nickname,
              },
            };
            if (Object.keys(this.promocodeInfo).length != 0) {
              obj["subscription_plan"]["promotion_code"] =
                this.promocodeInfo.id;
            }
            let payload = {
              to: this.data.email,
              plan: {
                price: this.subscription.subscription.plan.amount,
                interval: this.subscription.subscription.plan.nickname,
              },
            };
            console.log(payload);
            let request = await fetch(
              `${baseDomain}/sendPaymentConfirmationEmail`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
              }
            );
            await this.registers({ ...this.data, ...obj });
          }
        }
      } catch (err) {
        error = true;
        this.$store.commit("setAuthLoading", false);
        alert(err.message);
      }
    },

    mountCard() {
      let style = {
        base: {
          color: "#32325D",
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: "antialiased",
          padding: 15,
          fontSize: "16px",
          "::placeholder": {
            color: "#9E9E9E",
          },
        },
        invalid: {
          color: "#FA755A",
          iconColor: "#FA755A",
        },
      };
      card = elements.create("card", {
        style: style,
        hidePostalCode: true,
      });

      // setTimeout(() => {
      //   card.mount("#card-element");
      // }, 2000);
      card.mount("#card-element");
    },
  },
  async mounted() {
    await this.getSubscriptions();
    this.price_id = this.subscriptions.data.filter(
      (sub) => sub.active == true
    )[0].id;
  },
};
</script>

<style scoped></style>
